import { login } from "../api/login";
import env, { setEnv } from "./env";
import { setSharedScreens } from "./shared-screens";
import { tdLog } from "./td-logger";

const loginService = async ({ ssoToken, username, password }) => {
  tdLog("loginService");

  const isSSOLogin = !!ssoToken;

  if (isSSOLogin && env("AUTH_TOKEN")) {
    return Promise.resolve(env("MEMBER_ID"));
  }
  const resp = await login({ ssoToken, username, password });
  if (resp && !resp.error_code) {
    const parsedLoginResponse = parseLoginResponse(isSSOLogin, resp);

    setEnv({
      AUTH_TOKEN: parsedLoginResponse.authToken,
      MEMBER_ID: parsedLoginResponse.domainId
    });

    setSharedScreens(resp.screens || []);

    return Promise.resolve(parsedLoginResponse.domainId);
  }
  return Promise.resolve(null);
};

const parseLoginResponse = (isSSOLogin, resp) => {
  const loginData = !isSSOLogin
    ? resp.response_data.authentication
    : resp.authentication;
  setEnv({ AUTH_METHOD: "Bearer" });

  let authToken;
  let domainId;

  if (!isSSOLogin && loginData.auth_token) {
    // This is mostly an example app use case when credentials are passed
    authToken = loginData.auth_token;
    domainId = loginData.domain_id;
  } else if (loginData.jwt_token) {
    // This is the primary use case of passing an SSO token
    authToken = loginData.jwt_token;
    domainId = loginData.domain_id;
  } else if (loginData.client_token) {
    // This is the AM use case
    // The token needs to be base64 encoded before being passed through MAPI
    // as a "Basic" authorization header
    authToken = btoa(`${loginData.client_id}:${loginData.client_token}`);

    // ensures that new AMOS-to-TAS Members can register
    if (resp.member.member_id === 1) {
      domainId = -1;
    } else {
      domainId = resp.member.member_id;
    }

    setEnv({ AUTH_METHOD: "Basic" });
    setEnv({ OAUTH_REFRESH_TOKEN: loginData.client_refresh_token });

    // This enables the am_internal_sdk flow in MAPI
    if (loginData?.data?.internal_sdk) {
      setEnv({
        AUTHENTICATION_DATA: JSON.stringify({
          internal_sdk: loginData.data.internal_sdk
        })
      });
    }
  }

  return { authToken, domainId };
};

export default loginService;
